import React from 'react'
import { useState, useEffect, useRef } from "react";
import _ from 'lodash';
import { Accordion, AccordionTab } from 'primereact/accordion';
import DropdownElement from '../../../../Components/UiComponents/DropdownElement';
import { useForm, Controller } from 'react-hook-form';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import InputTextElement from '../../../../Components/UiComponents/InputTextElement';
import DataTable from "../../../../Components/UiComponents/DataTable";
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import { Dialog } from 'primereact/dialog';
import CreateNewContacts from '../../Stakeholders/ClientEdit/Address&Contact/createNewContacts';
import { addClientTeam, downloadDocs } from '../../../../Services/opportunityService';
import { Tooltip } from 'primereact/tooltip';
import { getOrgTeam } from '../../../../Services/organisationService';
import { updateExistClTeam } from '../../../../Services/opportunityService';
import { generateClientReport } from '../../../../Services/opportunityService';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import { getBranchUser } from '../../../../Services/userService';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import { getField } from '../../../../Services/tooltipService';
import Loader from '../../../../Components/UiComponents/Loader';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

const Objective = ((props) => {
  const { formState: { errors }, setValue, getValues, control } = useForm();
  const [opportunityData, setOpportunityData] = useState({});
  const [newModule, setNewModule] = useState([]);
  const [isTeamModelOpen, setTeamModelOpen] = useState(false);
  const [stakeVisible, setStakeVisible] = useState(false);
  const [teamVisible, setTeamVisible] = useState(false);
  const [orgTeam, setOrgTeam] = useState([]);
  const toastRef = useRef(null);
  const [editData, setEditData] = useState({});
  const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
  const [branchIdFromLS, setBranchIdFromLS] = useState();
  const [branchDetail, setBranchDetail] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [moduleNames, setModuleNames] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedOptionValues,setSelectedOptionValues] = useState([])
  const [selectedOptionNeeds,setSelectedOptionNeeds] = useState([])
  const [selectedOptionProObj,setSelectedOptionProObj] = useState([])
  const [selectedOptionProneeds,setSelectedOptionProneeds] = useState([])
  const [selectedOptionProValues,setSelectedOptionProValues] = useState([])
  const [selectedOptionObjective,setSelectedOptionObjective] = useState([])
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (props.opportunityData) {
      setOpportunityData(props.opportunityData)
      getTeamMember(props.opportunityData)
      getEditData(props.opportunityData);
    }
  }, [props.opportunityData]);

  useEffect(() => {
    if (props.opportunityData && orgTeam?.length > 0) {
      cliTeamMemberDetails(props.opportunityData, orgTeam)
    }
  }, [props.opportunityData, orgTeam])

  useEffect(() => {
    if (props.customerId) {
      getFieldData()
    }
  }, [props.customerId])

  useEffect(() => {
    if (props.objectiveData?.pipelineClientSections) {
      let obj1 = _.find(props.objectiveData?.pipelineClientSections, { section_name: "Client Information" })?.display_name;
      let obj2 = _.find(props.objectiveData?.pipelineClientSections, { section_name: "Client Insight" })?.display_name;
      let obj3 = _.find(props.objectiveData?.pipelineClientSections, { section_name: "Client Engagement Outcomes" })?.display_name;
      let combined = { obj1, obj2, obj3 };
      setNewModule(combined)
    }
  }, [props.objectiveData?.pipelineClientSections])

  function generateRandomID() {
    const hexChars = '0123456789abcdef';
    let result = '';
    for (let i = 0; i < 24; i++) {
      result += hexChars.charAt(Math.floor(Math.random() * hexChars?.length));
    }
    return result;
  }

  const getFieldData = async () => {
    setLoading(true);

    try {
      // Fetch field data for the customer
      const response = await getField(props.customerId);
      const clientModuleData = response.data;
      
      setModuleNames(clientModuleData.cust[0]?.modules);
        
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'Error fetching field data. Please try again or contact Admin.',
      });
    } finally {
      setLoading(false);
    }
  };
  

  const cliTeamMemberDetails = (opportunityDetails, orgData) => {
    if (opportunityDetails.client.client_info?.length >= 1) {
      for (var i = 0; i < opportunityDetails.client.client_info?.length; i++) {
        orgData.forEach((value) => {
          if (value._id === opportunityDetails.client.client_info[i].client_team_id) {
            opportunityDetails.client.client_info[i].client_team = value.full_name;
            opportunityDetails.client.client_info[i].client_role = value.role;
          }
        });
      }
    }
    setOpportunityData(prevState => ({
      ...prevState,
      opportunityDetails
    }))
  }
  useEffect(() => {
    getBranchUsers();
  }, [branchIdFromLS, props.customerId, props.branch]);

  useEffect(() => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      client: {
        ...prevData.client,
        project_brief: opportunityData?.client?.project_brief,
        project_needs: opportunityData?.client?.project_needs,
        project_objectives: opportunityData?.client?.project_objectives,
      },
    }));
  }, [opportunityData?.client]);

  useEffect(() => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      client: {
        ...prevData.client,
        client_info: opportunityData?.client?.client_info,
        opportunity_needs: opportunityData?.client?.opportunity_needs,
        opportunity_objectives: opportunityData?.client?.opportunity_objectives,
        opportunity_values: opportunityData?.client?.opportunity_values,
      },
      win_plan: {
        ...prevData.win_plan,
        project_brief: opportunityData?.win_plan?.project_brief,
        project_needs: opportunityData?.win_plan?.project_needs,
        project_objectives: opportunityData?.win_plan?.project_objectives,
        project_values: opportunityData?.win_plan?.project_values,
      },
    }));
  }, [opportunityData?.client, opportunityData?.win_plan, setGlobalOpportunityData]);

  useEffect(() => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      ...opportunityData,
    }));

  }, [opportunityData]);

  const getBranchUsers = async () => {
    setLoading(true); 
  
    // Ensure branchId is not null
    if (branchIdFromLS !== null) {
      try {
        // Fetch branch user data from the server
        const branchUserDataResponse = await getBranchUser(props?.customerId, props.branch?.branch_id);
        
        setBranchDetail(branchUserDataResponse.data);
        
        // toastRef.current.showToast({
        //   type: 'success',
        //   message: 'Branch user data fetched successfully!',
        // });
      } catch (error) {
        // Handle error and show an error toast
        // toastRef.current.showToast({
        //   type: 'error',
        //   message: 'Error fetching branch user data. Please try again.',
        // });
        console.log(error)
      } finally {
        setLoading(false);
      }
    } else {
      // Show error if branchId is not available
      toastRef.current.showToast({
        type: 'error',
        message: 'Branch ID is missing. Cannot fetch branch users.',
      });
      setLoading(false); 
    }
  };
  const generateClientReports = async () => {
    setLoading(true);
  
    try {  
      // Generate client report
      const response = await generateClientReport(props.opportunityData._id, props.customerId, opportunityData);
  
      // Check if the response has data and download the document
      if (response.data) {
        downloadDocs(response.data.fileName);
        // Show success toast notification
        toastRef.current.showToast({
          type: 'success',
          message: 'Client report generated successfully!',
        });
      } else {
        // Handle cases where no data is returned
        toastRef.current.showToast({
          type: 'error',
          message: 'No data received for the report.',
        });
      }
    } catch (error) {
      // Handle errors and show toast
      toastRef.current.showToast({
        type: 'error',
        message: 'Error generating client report. Please try again or contact Admin.',
      });
    } finally {
      setLoading(false);
    }
  };
  

  const getEditData = (opportunityDetails) => {
    if (opportunityDetails) {
      const edit = _.cloneDeep(opportunityDetails);
      if (edit.additional?.client_history && edit.opportunity?.client_meetings) {
        // edit.additional.client_history = props?.clientHistory.filter(
        //   (item) => item.label === opportunityDetails?.additional.client_history
        // )[0];

        edit.opportunity.client_meetings = props?.clientMeetings.filter(
          (item) => item.label === opportunityDetails?.opportunity.client_meetings
        )[0];
      }
      setEditData(edit);
    }
  }

  const loadTeamMember = () => {
    // setCheckedCheckboxes({});
    setTeamModelOpen(true);
  }

  const deleteTeamField = () => {
    const updatedOptions = opportunityData.client?.client_info.filter(
      (row) => !selectedOption.includes(row)
    );

    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        client_info: updatedOptions
      }
    }));
    setSelectedOption([]);
  };

  const closeTeamDialog = () => {
    setLoading(false)
    setTeamModelOpen(false);
    setSelectedOption([])
    setValue("team", [])
  }

  const handleTeamHide = (data) => {
    setTeamVisible(data);
    setSelectedOption([]);
  }

  const renderTeamFooter = () => {
    return (
      <div className="cancel-footer">
        <div className='align-center justify-end pb-0'>
          <ButtonElement type="button" className="save-button" label="Add" onClick={addTeamMember} />
        </div>
      </div>
    );
  };

  const addNewMembers = async (teamData) => {
    if (teamData) {
        try {
            // Convert email to lowercase
            teamData.email = teamData.email.toLowerCase();

            // Set label to first name + last name
            teamData.label = `${teamData.first_name} ${teamData.last_name}`;

            // API call to add a client team member
            const response = await addClientTeam(
                opportunityData._id, 
                props.customerId, 
                opportunityData?.client_id, 
                opportunityData?.client_name, 
                teamData
            );

            if (response.data) {
                // Check for success in the response
                if (response.data.success) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: response.data.message,
                    });

                    opportunityData.client.client_info = response.data.result;
                    setOpportunityData(opportunityData);

                    cliTeamMemberDetails(opportunityData, orgTeam);
                    props.getData('success');

                    setSelectedOption([]);
                    setTeamModelOpen(false);
                } else {
                    // Display error toast with the message from the response
                    toastRef.current.showToast({
                        type: 'error',
                        message: response.data.message,
                    });
                }
            } else {
              toastRef.current.showToast({
                type: 'error',
                message: 'No data received from the API',
            });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while adding the team member. Please try again or contact Admin',
            });
        }
    } else {
        // Show error if teamData is not provided or is invalid
        toastRef.current.showToast({
            type: 'error',
            message: 'Fields are required / invalid',
        });
    }
};

  const addTeamMember = async () => {
    setLoading(true);

    try {
        const selectedTeamMember = getValues("team");

        // Check if any team member is selected
        if (_.isEmpty(selectedTeamMember)) {
            toastRef.current.showToast({
                type: 'error',
                message: 'Please select at least one team member',
            });
            return;
        }

        // Make the API call to update the client team
        const data = await updateExistClTeam(opportunityData._id, props.customerId, opportunityData?.client_name, selectedTeamMember);

        // Handle response from API
        if (data.data) {
            if (data.data.status === 'warning') {
                toastRef.current.showToast({
                    type: 'error',
                    message: data.data.message,
                });
            } else if (data.data.success) {
                opportunityData.client.client_info = data.data.result;
                setOpportunityData(opportunityData);
                
                toastRef.current.showToast({
                    type: 'success',
                    message: data.data.message,
                });

                props.getData('success');
                cliTeamMemberDetails(opportunityData, orgTeam);
                setSelectedOption([]);
                setTeamModelOpen(false);
                setValue("team", []);
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: data.data.message,
                });
            }
        }
    } catch (error) {
        toastRef.current.showToast({
            type: 'error',
            message: 'Error adding team member. Please try again or contact Admin.',
        });
    } finally {
        setLoading(false);
    }
};


  const [option, setOption] = useState([
    { isCompleted: "", _id: "", needs: "", action_owner: "" },
  ]);

  const onTextChangeNeeds = (index, field) => (e) => {
    const newClientNeeds = [...opportunityData?.client?.opportunity_needs];
    if (newClientNeeds[index] !== undefined) {
      newClientNeeds[index].needs = e.target.value;
      setOpportunityData({ ...opportunityData, opportunity_needs: newClientNeeds });
    }
  };

  const onTextChangeSpecificNeeds = (index, field) => (e) => {
    const newClientNeeds = [...opportunityData?.win_plan?.project_needs];
    if (newClientNeeds[index] !== undefined) {
      newClientNeeds[index].needs = e.target.value;
      setOpportunityData({ ...opportunityData, project_needs: newClientNeeds });
    }
  };

  const onTextChangeObjectives = (index, field) => (e) => {
    const newClientObjectives = [...opportunityData?.client?.opportunity_objectives];
    if (newClientObjectives[index] !== undefined) {
      newClientObjectives[index].objectives = e.target.value;
      setOpportunityData({ ...opportunityData, opportunity_objectives: newClientObjectives });
    }
  };

  const onTextChangeSpecificObjectives = (index, field) => (e) => {
    const newClientObjectives = [...opportunityData?.win_plan?.project_objectives];
    if (newClientObjectives[index] !== undefined) {
      newClientObjectives[index].objectives = e.target.value;
      setOpportunityData({ ...opportunityData, project_objectives: newClientObjectives });
    }
  };

  const onTextChangeValues = (index, field) => (e) => {
    const newClientValues = [...opportunityData?.client?.opportunity_values];
    if (newClientValues[index] !== undefined) {
      newClientValues[index].values = e.target.value;
      setOpportunityData({ ...opportunityData, opportunity_values: newClientValues });
    }
  };

  const onTextChangeSpecificValues = (index, field) => (e) => {
    const newClientValues = [...opportunityData?.win_plan?.project_values];
    if (newClientValues[index] !== undefined) {
      newClientValues[index].values = e.target.value;
      setOpportunityData({ ...opportunityData, project_values: newClientValues });
    }
  };

  const checkingTeamDisplayName = (rowData) => {
    if (rowData.client_team != null && rowData.client_team !== "") {
      return <div>{rowData.client_team}</div>;
    } else {
      return <div>No Results Found</div>;
    }
  };

  const checkingRole = (rowData) => {
    if (rowData.client_role != null && rowData.client_role !== "") {
      return <div>{rowData.client_role}</div>;
    } else {
      return <div>No Results Found</div>;
    }
  };

  const onChangeLead = (position, entities) => {
    const updatedEntities = entities.map((subscription, index) => {
      return {
        ...subscription,
        lead: position === index
      };
    });

    // Ensure that you are updating the state with a new object reference
    setOpportunityData(prevOpportunityData => ({
      ...prevOpportunityData,
      client: {
        ...prevOpportunityData.client,
        client_info: updatedEntities
      }
    }));
  }

  const checkingLeadName = (rowData, index) => {
    return (
      <RadioElement
        id="lead"
        options={[{ key: true, name: "" }]}
        value={rowData.lead}
        onChangeRadio={(e) => onChangeLead(index.rowIndex, opportunityData.client?.client_info)}
        className="radio-group-class"
      />
    )
  };

  const handleInputChange = (field1, field2, field3, value, index) => {
    setOpportunityData((prevOpportunityDetails) => ({
      ...prevOpportunityDetails,
      [field1]: {
        ...prevOpportunityDetails[field1],
        [field2]: prevOpportunityDetails[field1][field2].map((item, idx) =>
          idx === index ? { ...item, [field3]: value.target.value } : item
        ),
      },
    }));
  };

  const checkingSPN = (rowData, index) => {
    return (
      <InputTextElementElement
        id="specific_needs"
        name="specific_needs"
        value={rowData.specific_needs}
        onChange={e => handleInputChange("client", "client_info", "specific_needs", e, index.rowIndex)}
        className="w-full"
      />
    )
  };

  const needsEditor = (row, index) => {
    return (
      <div className="flex align-items-center">
        <InputTextElement
          className={(props.errors.includes('Opportunity Needs') && row.needs == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
          value={row.needs}
          placeholder="Description"
          onChange={onTextChangeNeeds(index?.rowIndex, "needs")}
        />
      </div>
    );
  };

  const specificNeedsEditor = (row, index) => {
    return (
      <div className="flex align-items-center">
        <InputTextElement
          className={(props.errors.includes('Project Needs') && row.needs == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
          value={row.needs}
          placeholder="Description"
          onChange={onTextChangeSpecificNeeds(index?.rowIndex, "needs")}
        />
      </div>
    );
  };

  const objectivesEditor = (row, index) => {
    return (
      <div className="flex align-items-center">
        <InputTextElement
          className={(props.errors.includes('Opportunity Objectives') && row.objectives == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
          value={row.objectives}
          placeholder="Description"
          onChange={onTextChangeObjectives(index?.rowIndex, "objectives")}
        />
      </div>
    );
  };

  const specificObjectiveEditor = (row, index) => {
    return (
      <div className="flex align-items-center">
        <InputTextElement
          className={(props.errors.includes('Project Objectives') && row.objectives == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
          value={row.objectives}
          placeholder="Description"
          onChange={onTextChangeSpecificObjectives(index?.rowIndex, "objectives")}
        />
      </div>
    );
  };

  const specificValuesEditor = (row, index) => {
    return (
      <div className="flex align-items-center">
        <InputTextElement
          className={(props.errors.includes('Project Values') && row.values == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
          value={row.values}
          placeholder="Description"
          onChange={onTextChangeSpecificValues(index?.rowIndex, "values")}
        />
      </div>
    );
  };

  const valuesEditor = (row, index) => {
    return (
      <div className="flex align-items-center">
        <InputTextElement
          className={(props.errors.includes('Opportunity Values') && row.values == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
          value={row.values}
          placeholder="Description"
          onChange={onTextChangeValues(index?.rowIndex, "values")}
        />
      </div>
    );
  };

  const teamColumns = [
    {
      field: 'stakeholders_team',
      header: _.find(props?.objectiveData?.oppClientHeaders, { header_name: "Clients Team" })?.display_name,
      body: checkingTeamDisplayName,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
    {
      field: 'role',
      header: _.find(props?.objectiveData?.oppClientHeaders, { header_name: "Role" })?.display_name,
      body: checkingRole,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
    {
      field: 'lead',
      header: _.find(props?.objectiveData?.oppClientHeaders, { header_name: "Lead" })?.display_name,
      body: checkingLeadName,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
    {
      field: 'specific_individual_needs',
      header: _.find(props.objectiveData?.oppClientHeaders, { header_name: "Specific Needs" })?.display_name,
      body: checkingSPN,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    }
  ]

  const outputColumns = [
    {
      field: "needs",
      header: _.find(props.objectiveData?.oppClientTable, { table_name: "Clients Stated Project Needs" })?.display_name,
      body: needsEditor,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
  ]

  const outputColumnsObjectives = [
    {
      field: "needs",
      header: _.find(props.objectiveData?.oppClientTable, { table_name: "Clients Stated Project Objectives" })?.display_name,
      body: objectivesEditor,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
  ]

  const outputColumnsValues = [
    {
      field: "values",
      header: _.find(props.objectiveData?.oppClientTable, { table_name: "Clients Stated Project Values" })?.display_name,
      body: valuesEditor,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
  ]

  const outputColumnsSpecificNeeds = [
    {
      field: "values",
      header: _.find(props.objectiveData?.oppClientTable, { table_name: "Specific Project Outputs" })?.display_name,
      body: specificNeedsEditor,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
  ]

  const outputColumnsSpecificObjectives = [
    {
      field: "values",
      header: _.find(props.objectiveData?.oppClientTable, { table_name: "Specific Project Deliverables" })?.display_name,
      body: specificObjectiveEditor,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
  ]

  const outputColumnsSpecificValues = [
    {
      field: "values",
      header: _.find(props.objectiveData?.oppClientTable, { table_name: "Specific Project Performance" })?.display_name,
      body: specificValuesEditor,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
  ]

  const rowClick1 = async (data) => {
    setSelectedOption(data)
  };
 
  const rowClick2 = async (data) => {
    setSelectedOptionNeeds(data)
  };
  const rowClick3 = async (data) => {
    setSelectedOptionObjective(data)
  };
  const rowClick4 = async (data) => {
    setSelectedOptionValues(data)
  };
  const rowClick5 = async (data) => {
    setSelectedOptionProneeds(data)
  };
  const rowClick6 = async (data) => {
    setSelectedOptionProObj(data)
  };
  const rowClick7 = async (data) => {
    setSelectedOptionProValues(data)
  };

  const addItem = () => {
    const newRow = {
      isCompleted: false,
      _id: generateRandomID(),
      needs: "",
      action_owner: []
    };
    setOption([...option, newRow]);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        opportunity_needs: [...prevState.client.opportunity_needs, newRow]
      }
    }));
  };

  const addItemObjectives = () => {
    const newRow = {
      isCompleted: false,
      _id: generateRandomID(),
      objectives: "",
      action_owner: []
    };
    setOption([...option, newRow]);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        opportunity_objectives: [...prevState.client.opportunity_objectives, newRow]
      }

    }));
  };

  const addItemValues = () => {
    const newRow = {
      isCompleted: false,
      _id: generateRandomID(),
      values: "",
      action_owner: []
    };
    setOption([...option, newRow]);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        opportunity_values: [...prevState.client.opportunity_values, newRow]
      }

    }));
  };

  const addItemProjectNeeds = () => {
    const newRow = {
      isCompleted: false,
      _id: generateRandomID(),
      needs: "",
      action_owner: []
    };
    setOption([...option, newRow]);
    setOpportunityData(prevState => ({
      ...prevState,
      win_plan: {
        ...prevState.win_plan,
        project_needs: [
          ...(prevState.win_plan.project_needs || []),
          newRow
        ]
      }
    }));
  };

  const addItemProjectObjectives = () => {
    const newRow = {
      isCompleted: false,
      _id: generateRandomID(),
      objectives: "",
      action_owner: []
    };
    setOption([...option, newRow]);
    setOpportunityData(prevState => ({
      ...prevState,
      win_plan: {
        ...prevState.win_plan,
        project_objectives: [
          ...(prevState.win_plan.project_objectives || []),
          newRow
        ]
      }
    }));
  };

  const addItemProjectValues = () => {
    const newRow = {
      isCompleted: false,
      _id: generateRandomID(),
      values: "",
      action_owner: []
    };
    setOption([...option, newRow]);
    setOpportunityData(prevState => ({
      ...prevState,
      win_plan: {
        ...prevState.win_plan,
        project_values: [
          ...(prevState.win_plan.project_values || []),
          newRow
        ]
      }
    }));
  };

  const handleDeleteOption = () => {
    const updatedOptions = opportunityData.client?.opportunity_needs.filter(
      (row) => !selectedOptionNeeds.includes(row)
    );
    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        opportunity_needs: updatedOptions
      }
    }));
    setSelectedOptionNeeds([]);
  };

  const handleDeleteOptionObjective = () => {
    const updatedOptions = opportunityData.client?.opportunity_objectives.filter(
      (row) => !selectedOptionObjective.includes(row)
    );
    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        opportunity_objectives: updatedOptions
      }
    }));
    setSelectedOptionObjective([]);
  };

  const handleDeleteOptionValues = () => {
    const updatedOptions = opportunityData.client?.opportunity_values.filter(
      (row) => !selectedOptionValues.includes(row)
    );
    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      client: {
        ...prevState.client,
        opportunity_values: updatedOptions
      }
    }));
    setSelectedOptionValues([]);
  };

  const handleDeleteOptionProjectNeeds = () => {
    const updatedOptions = opportunityData.win_plan.project_needs.filter(
      (row) => !selectedOptionProneeds.includes(row)
    );
    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      win_plan: {
        ...prevState.win_plan,
        project_needs: updatedOptions
      }
    }));
    setSelectedOptionProneeds([]);
  };

  const handleDeleteOptionProjectObj = () => {
    const updatedOptions = opportunityData.win_plan.project_objectives.filter(
      (row) => !selectedOptionProObj.includes(row)
    );
    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      win_plan: {
        ...prevState.win_plan,
        project_objectives: updatedOptions
      }
    }));
    setSelectedOptionProObj([]);
  };

  const handleDeleteOptionProjectValues = () => {
    const updatedOptions = opportunityData.win_plan.project_values.filter(
      (row) => !selectedOptionProValues.includes(row)
    );
    setOption(updatedOptions);
    setOpportunityData(prevState => ({
      ...prevState,
      win_plan: {
        ...prevState.win_plan,
        project_values: updatedOptions
      }
    }));
    setSelectedOptionProValues([]);
  };


  const handleRadioChange = (value) => {
    setSelectedOption(value);
    if (value === 'new') {
      setStakeVisible(true);
      setTeamVisible(true);
    }
  };
  const getTeamMember = async (opportunityDetails) => {
    setLoading(true);

    try {
        if (opportunityDetails?.client_id && props?.customerId) {
            // Fetch organization team data
            const response = await getOrgTeam(opportunityDetails.client_id, props.customerId);
            
            if (response?.data?.organisation) {
                setOrgTeam(response.data.organisation);
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'No organization data found in response',
                });
            }
        } else {
            toastRef.current.showToast({
                type: 'error',
                message: 'Missing opportunity details or customer ID',
            });
        }
    } catch (error) {
        toastRef.current.showToast({
            type: 'error',
            message: 'Error fetching team member data. Please try again.',
        });
    } finally {
        setLoading(false);
    }
};

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
      setShowVideo(false);
  };


  return (
    <div className='new-field'>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="col-md-12 text-right">
          <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      {
        Object.entries(newModule).map(([key, value]) => (
          <div key={key} className='mt-10'>
            <Accordion activeIndex={0}>
              {
                <AccordionTab header={value} disabled>
                  {
                    key == 'obj1' &&
                    <div className="new-field d-flex">
                      <div className='col pl-0'>
                        {
                          _.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Name" })?.field_status === true &&
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">{_.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
                            </div>
                            <div className="col-md-1 pl-0">
                            </div>
                            <div className='col pr-0'>
                              <label className="form-label text-left">{opportunityData?.client_name}</label>
                            </div>
                          </div>
                        }
                        {
                          _.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Classification" })?.field_status === true &&
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">{_.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Classification" })?.display_name}:</label>
                            </div>
                            <div className="col-md-1 pl-0">
                            </div>
                            <div className='col pr-0'>
                              <label className="form-label text-left">
                                {
                                  props?.clientDetails?.client_classification?.length && props?.clientDetails?.client_classification.map((classification, index) => {
                                    return (
                                      <li key={index} className="form-label text-left">
                                        {classification.label}
                                      </li>
                                    )
                                  })
                                }
                              </label>
                            </div>
                          </div>
                        }
                        {
                          _.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Status" })?.field_status === true &&
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">{_.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Status" })?.display_name}:</label>
                            </div>
                            <div className="col-md-1 pl-0">
                            </div>
                            <div className='col pr-0'>
                              <label className="form-label text-left">{props?.clientDetails?.client_status}</label>
                            </div>
                          </div>
                        }
                        {
                          _.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Type" })?.field_status === true &&
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">{_.find(props.objectiveData?.clientFieldsNew, { field_name: "Client Type" })?.display_name}:</label>
                            </div>
                            <div className="col-md-1 pl-0">
                            </div>
                            <div className='col pr-0'>
                              {
                                props?.clientDetails?.client_type?.length && props?.clientDetails?.client_type.map((type, index) => {
                                  return (
                                    <li key={index} className="form-label text-left">
                                      {type.label}
                                    </li>
                                  )
                                })
                              }
                            </div>
                          </div>
                        }
                        {
                          _.find(props.objectiveData?.clientFieldsNew, { field_name: "Relationship Owner" })?.field_status === true &&
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">{_.find(props.objectiveData?.clientFieldsNew, { field_name: "Relationship Owner" })?.display_name}:</label>
                            </div>
                            <div className="col-md-1 pl-0">
                            </div>
                            <div className='col pr-0'>
                              <label className="form-label text-left">{opportunityData?.relationship_owner}</label>
                            </div>
                          </div>
                        }
                        <div className="new-field d-flex">
                          <div className='col pl-0'>
                            {
                              _.find(props.objectiveData?.oppClientTable, { table_name: "Client's Organisation Stakeholders" })?.status &&
                              <div className="box-border">
                                <div className="form-group row align-items-center mb-0">
                                  <div className="col-md-6 pl-0">
                                    <p className="label-text">
                                      {_.find(props.objectiveData?.oppClientTable, { table_name: "Client's Organisation Stakeholders" })?.display_name}
                                    </p>
                                  </div>
                                  <div className="col pr-0 d-flex justify-end">
                                    <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={() => deleteTeamField()} />
                                    <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={loadTeamMember} />
                                  </div>
                                </div>
                                <div>
                                  <DataTable
                                    value={opportunityData.client?.client_info}
                                    columns={teamColumns}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick1}
                                  />
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  {
                    key == 'obj2' &&
                    <div>
                      <div className="new-field d-flex">
                        <div className='col-md-6 pl-0'>
                          {
                            _.find(props.objectiveData?.projectSelectFields, { field_name: "Client History" })?.field_status === true &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">{_.find(props.objectiveData?.projectSelectFields, { field_name: "Client History" })?.display_name}:</label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {
                                  props.customerTooltipDataOthers?.client?.client_history?.status == true &&
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={props.customerTooltipDataOthers?.client?.client_history?.text}
                                      data-pr-position="right">
                                    </i>
                                  </div>
                                }
                              </div>
                              <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                <Controller
                                  name="ClientHistory"
                                  control={control}
                                  style={{ innerHeight: 10 }}
                                  defaultValue={props?.clientHistory.filter(
                                    (item) => item.label === globalOpportunityData?.additional?.client_history
                                  )[0]}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        onChangeValue={(e) => field.onChange(e.value)}
                                        id="ClientHistory"
                                        options={(props?.clientHistory != undefined && props?.clientHistory?.length > 0) ? props?.clientHistory : []}
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        maxSelectedLabels={1}
                                        value={field.value || props?.clientHistory.filter(
                                          (item) => item.label === globalOpportunityData?.additional?.client_history
                                        )[0]}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["ClientHistory"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              client_history: e.value.label
                                            }
                                          }));
                                          setOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              client_history: e.value.label
                                            }
                                          }));
                                          props.computeScore(1, "ClientHistory", e.value, props?.clientHistory.filter(
                                            (item) => item.label === globalOpportunityData?.additional?.client_history
                                          )[0]);
                                          field.onChange(e.value)
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          }
                          {
                            _.find(props.objectiveData?.pipelineClientFields, { field_name: "Depth of Client Engagement" })?.field_status === true &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">{_.find(props.objectiveData?.pipelineClientFields, { field_name: "Depth of Client Engagement" })?.display_name}:</label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {
                                  props.customerTooltipDataOthers?.client?.depth_of_client_engagement?.status == true &&
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={props.customerTooltipDataOthers?.client?.depth_of_client_engagement?.text}
                                      data-pr-position="right">
                                    </i>
                                  </div>
                                }
                              </div>
                              <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                <Controller
                                  name="ClientMeetings"
                                  control={control}
                                  style={{ innerHeight: 10 }}
                                  defaultValue={editData?.opportunity?.client_meetings}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        onChangeValue={(e) => field.onChange(e.value)}
                                        id="ClientMeetings"
                                        options={(props?.clientMeetings != undefined && props?.clientMeetings?.length > 0) ? props?.clientMeetings : []}
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        maxSelectedLabels={1}
                                        value={field.value || editData?.opportunity?.client_meetings}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["ClientMeetings"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            opportunity: {
                                              ...prevData.opportunity,
                                              client_meetings: e.value.label
                                            }
                                          }));
                                          setOpportunityData((prevData) => ({
                                            ...prevData,
                                            opportunity: {
                                              ...prevData.opportunity,
                                              client_meetings: e.value.label
                                            }
                                          }));
                                          props.computeScore(2, "ClientMeetings", e.value, editData?.opportunity?.client_meetings);
                                          field.onChange(e.value)
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          }
                          {
                            _.find(props.objectiveData?.pipelineClientFields, { field_name: "Project Priorities" })?.field_status === true &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">{_.find(props.objectiveData?.pipelineClientFields, { field_name: "Project Priorities" })?.display_name}:</label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {
                                  props.customerTooltipDataOthers?.client?.opportunity_drivers?.status == true &&
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={props.customerTooltipDataOthers?.client?.opportunity_drivers?.text}
                                      data-pr-position="right">
                                    </i>
                                  </div>
                                }
                              </div>
                              <div className='col pr-0'>
                                <TextareaElement
                                  placeholder="Text"
                                  name="opportunity_drivers"
                                  className="w-full"
                                  // defaultValue={opportunityData?.client?.opportunity_drivers}
                                  value={opportunityData?.client?.opportunity_drivers}
                                  rows={3}
                                  onChange={(e) => {
                                    setOpportunityData((prevData) => ({
                                      ...prevData,
                                      client: {
                                        ...prevData.client,
                                        opportunity_drivers: e.target.value
                                      }
                                    }));
                                  }
                                  }
                                />
                              </div>
                            </div>
                          }
                          {
                            _.find(props.objectiveData?.pipelineClientFields, { field_name: "Project Brief" })?.field_status === true &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">{_.find(props.objectiveData?.pipelineClientFields, { field_name: "Project Brief" })?.display_name}:</label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {
                                  props.customerTooltipDataOthers?.client?.opportunity_brief?.status == true &&
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={props.customerTooltipDataOthers?.client?.opportunity_brief?.text}
                                      data-pr-position="right">
                                    </i>
                                  </div>
                                }
                              </div>
                              <div className='col pr-0'>
                                <TextareaElement
                                  placeholder="Text"
                                  name="opportunity_brief"
                                  className="w-full"
                                  // defaultValue={opportunityData?.client?.opportunity_brief}
                                  rows={3}
                                  value={opportunityData?.client?.opportunity_brief}
                                  onChange={(e) => {
                                    setOpportunityData((prevData) => ({
                                      ...prevData,
                                      client: {
                                        ...prevData.client,
                                        opportunity_brief: e.target.value
                                      }
                                    }));
                                  }
                                  }
                                />
                              </div>
                            </div>
                          }
                        </div>
                        <div className="col-md-6 pl-0">
                          {
                            _.find(props.objectiveData?.oppClientTable, { table_name: "Clients Stated Project Needs" })?.status &&
                            <div className="col pl-0 box-border-plan ml-10">
                              <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col pr-0 pt-0">
                                  <div className="form-group row align-items-center mb-0">
                                    <div className="col pr-0 d-flex justify-end">
                                      <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOption} />
                                      <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItem} />
                                    </div>
                                  </div>
                                  <DataTable
                                    value={opportunityData?.client?.opportunity_needs}
                                    columns={outputColumns}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick2}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="new-field d-flex mt-20">
                        <div className='col-md-6 pl-0'>
                          {
                            _.find(props.objectiveData?.oppClientTable, { table_name: "Clients Stated Project Objectives" })?.status &&
                            <div className="col pl-0 box-border-plan ml-10">
                              <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col pr-0 pt-0">
                                  <div className="form-group row align-items-center mb-0">
                                    <div className="col pr-0 d-flex justify-end">
                                      <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOptionObjective} />
                                      <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemObjectives} />
                                    </div>
                                  </div>
                                  <DataTable
                                    value={opportunityData?.client?.opportunity_objectives}
                                    columns={outputColumnsObjectives}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick3}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div className='col-md-6 pl-0'>
                          {
                            _.find(props.objectiveData?.oppClientTable, { table_name: "Clients Stated Project Values" })?.status &&
                            <div className="col pl-0 box-border-plan ml-10">
                              <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col pr-0 pt-0">
                                  <div className="form-group row align-items-center mb-0">
                                    <div className="col pr-0 d-flex justify-end">
                                      <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOptionValues} />
                                      <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemValues} />
                                    </div>
                                  </div>
                                  <DataTable
                                    value={opportunityData?.client?.opportunity_values}
                                    columns={outputColumnsValues}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick4}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {
                    key == 'obj3' &&

                    <div>
                      <div className="new-field d-flex">
                        <div className='col-md-12 pl-0'>
                          {
                            _.find(props.objectiveData?.pipelineClientFields, { field_name: "Project Priorities" })?.field_status === true &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">{_.find(props.objectiveData?.pipelineClientFields, { field_name: "Specific Client Preferences: (drivers, values, results, performance, methodology, approaches, arrangements, milestones, concerns,  expectations etc)" })?.display_name}:</label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {
                                  props.customerTooltipDataOthers?.client.project_drivers.status == true &&
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={props.customerTooltipDataOthers?.client.project_drivers.text}
                                      data-pr-position="right">
                                    </i>
                                  </div>
                                }
                              </div>
                              <div className='col pr-0'>
                                <TextareaElement
                                  placeholder="Text"
                                  name="opportunity_drivers"
                                  className="w-full"
                                  // defaultValue={opportunityData?.win_plan?.project_brief}
                                  rows={9}
                                  value={opportunityData?.win_plan?.project_brief}
                                  onChange={(e) => {
                                    setOpportunityData((prevData) => ({
                                      ...prevData,
                                      win_plan: {
                                        ...prevData.win_plan,
                                        project_brief: e.target.value
                                      }
                                    }));
                                  }
                                  }
                                />
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="new-field d-flex">
                        <div className='col-md-6 pl-0'>
                          {
                            _.find(props.objectiveData?.oppClientTable, { table_name: "Specific Project Outputs" })?.status &&
                            <div className="col pl-0 box-border-plan ml-10">
                              <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col pr-0 pt-0">
                                  <div className="form-group row align-items-center mb-0">
                                    <div className="col pr-0 d-flex justify-end">
                                      <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOptionProjectNeeds} />
                                      <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemProjectNeeds} />
                                    </div>
                                  </div>
                                  <DataTable
                                    value={opportunityData?.win_plan?.project_needs}
                                    columns={outputColumnsSpecificNeeds}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick5}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div className="col-md-6 pl-0">
                          {
                            _.find(props.objectiveData?.oppClientTable, { table_name: "Specific Project Deliverables" })?.status &&
                            <div className="col pl-0 box-border-plan ml-10">
                              <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col pr-0 pt-0">
                                  <div className="form-group row align-items-center mb-0">
                                    <div className="col pr-0 d-flex justify-end">
                                      <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOptionProjectObj} />
                                      <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemProjectObjectives} />
                                    </div>
                                  </div>
                                  <DataTable
                                    value={opportunityData?.win_plan?.project_objectives}
                                    columns={outputColumnsSpecificObjectives}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick6}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="new-field d-flex mt-20">
                        <div className='col-md-6 pl-0'>
                          {
                            _.find(props.objectiveData?.oppClientTable, { table_name: "Specific Project Performance" })?.status &&
                            <div className="col pl-0 box-border-plan ml-10">
                              <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col pr-0 pt-0">
                                  <div className="form-group row align-items-center mb-0">
                                    <div className="col pr-0 d-flex justify-end">
                                      <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOptionProjectValues} />
                                      <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemProjectValues} />
                                    </div>
                                  </div>
                                  <DataTable
                                    value={opportunityData?.win_plan?.project_values}
                                    columns={outputColumnsSpecificValues}
                                    dataKey="_id"
                                    isNotReorder={true}
                                    rowClick={rowClick7}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </AccordionTab>
              }
            </Accordion>
          </div>
        ))
      }
      <Dialog
        visible={isTeamModelOpen}
        className='width-32'
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={`${_.find(moduleNames, { module_name: "Clients" })?.display_name} Team`}
        modal
        position="center"
        onHide={closeTeamDialog}
        footer={renderTeamFooter()}
        draggable={false}
      >
        <div className='new-field'>
          <RadioElement
            id="team_member"
            options={[{ key: 'new', name: "Add New Member" }, { key: 'exist', name: "Existing Member" }]}
            value={selectedOption}
            onChangeRadio={handleRadioChange}
            className="radio-group-class"
          />
        </div>
        {selectedOption === 'new' && (
          <CreateNewContacts
            objective={true}
            visible={teamVisible}
            position={'right'}
            customerId={props?.customerId}
            clientName={props?.clientName}
            fieldDetail={props?.fieldDetails}
            onHide={handleTeamHide}
            addressDetails={props?.addressDetails}
            clientSectionsSummary={props.objectiveData?.clientSectionsSummary}
            commonFields={props.objectiveData?.commanFieldsNew}
            addressContactFields={props.objectiveData?.addressContactFields}
            addTeamMember={(data) => addNewMembers(data)}
          />
        )}
        {selectedOption === 'exist' && (
          <>
            <div className="form-group row align-items-center mb-0 mt-10">
              <div className="col-md-5 pl-0">
                <label className="form-label text-left">Select Team Member:</label>
              </div>
              <div className='col pr-0'>
                <Controller
                  name="team"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => {
                    const teamOptions = orgTeam?.map((team) => ({
                      value: team,
                      label: team.full_name,
                    }));
                    return (
                      <MultiSelectElement
                        onChangeValue={(e) => field.onChange(e.value)}
                        id="sector"
                        options={teamOptions}
                        optionLabel="label"
                        placeholder="-- Please Select Team Member --"
                        className="w-full"
                        {...field}
                        maxSelectedLabels={1}
                        value={field.value}
                      />
                    );
                  }}
                />
              </div>
            </div>
          </>
        )}
      </Dialog>
      <Dialog id="videoModal" visible={showVideo}
          breakpoints={{
              '1200px': '80vw',    // Larger modal on bigger screens
              '1024px': '85vw',    // Slightly smaller for medium screens
              '769': '90vw',     // Responsive on tablets
              '641px': '95vw',     // Almost full-width on mobile
          }}
          modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
      >
          <div className="video-overlay">
              <div className="video-container">
                  <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_objectives" />
              </div>
          </div>
      </Dialog>
      <div className="cancel-footer mt-20">
        <div className='d-flex align-center justify-end pb-0'>
          <ButtonElement className="save-button" type="submit" label={`Generate ${props.pipelineClientsubmodule} Report`} onClick={generateClientReports} />
        </div>
      </div>
    </div>
  )
})

export default Objective